import { httpClient } from 'utils/httpClient';
import {
  TutorMatriculaPayload, TutorMatriculaResponse,
  DatosSaludPayload, DatosSaludResponse,
} from 'types/fum.types';
import { MatriculaResponse } from 'types/matricula.types';

export const tutorMatriculaService = {
  async listarPorMatricula(matriculaId: number): Promise<TutorMatriculaResponse[]> {
    try {
      return await httpClient.get<TutorMatriculaResponse[]>(`/tutores-matricula/matricula/${matriculaId}`);
    } catch { return []; }
  },
  async crear(payload: TutorMatriculaPayload): Promise<TutorMatriculaResponse> {
    return httpClient.post<TutorMatriculaResponse>('/tutores-matricula', payload);
  },
  async actualizar(id: number, payload: TutorMatriculaPayload): Promise<TutorMatriculaResponse> {
    return httpClient.put<TutorMatriculaResponse>(`/tutores-matricula/${id}`, payload);
  },
  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/tutores-matricula/${id}`);
  },
};

export const datosSaludService = {
  async getByMatricula(matriculaId: number): Promise<DatosSaludResponse | null> {
    try {
      return await httpClient.get<DatosSaludResponse>(`/datos-salud-matricula/matricula/${matriculaId}`);
    } catch { return null; }
  },
  async upsert(payload: DatosSaludPayload): Promise<DatosSaludResponse> {
    return httpClient.put<DatosSaludResponse>('/datos-salud-matricula', payload);
  },
};

export const matriculaSiagieService = {
  async asignarCodigo(matriculaId: number, codigoMatricula: string): Promise<MatriculaResponse> {
    return httpClient.patch<MatriculaResponse>(`/matriculas/${matriculaId}/codigo-siagie`, { codigoMatricula });
  },
};
